import Rom from '@organisms/ORom'


const CoachRom = () => <Rom />


export default CoachRom
